import loadable from '@loadable/component'
import { TemplateLoaderProps } from '@saastack/core/types'

const MeetingTemplate = loadable(() => import('@appointy/client-meetings-template'))
const MinimalTemplate = loadable(() => import('@appointy/client-minimal-template'))

const templates: Record<string, TemplateLoaderProps['template']> = {
    meeting: MeetingTemplate,
    minimal: MinimalTemplate,
}

export default templates
